import React, { Component } from 'react'
import JsonField from './JsonField'
import LabeledTextAreaField from './LabeledTextAreaField'

export default class LabeledJsonField extends Component {
  static propTypes = {
    ...LabeledTextAreaField.props
  }

  render() {
    const {
      label,
      name,
      handleChange,
      handleBlur,
      errorMessage,
      value,
      cssClasses,
      inputCssClass,
      fieldName,
      disabled,
      rows,
      placeholder,
      labelCssClass
    } = this.props

    const title = this.props.title || label

    return (
      <div id={name} className={cssClasses}>
        <label>
          <div className={labelCssClass}>{label}</div>
          <JsonField
            name={name}
            title={title}
            fieldName={fieldName}
            handleChange={handleChange}
            handleBlur={handleBlur}
            errorMessage={errorMessage}
            value={value}
            rows={rows}
            disabled={disabled}
            inputCssClass={inputCssClass}
            placeholder={placeholder}
          />
        </label>
      </div>
    )
  }
}
